import React, { createContext, useState, useContext, useEffect } from 'react';
import { getThemeColors, getThemeMode, saveThemeColors, saveThemeMode } from './themeColourManager';

const ThemeContext = createContext();

const themes = {
    boxphish: {
        primary: '#74E1BF',
        secondary: '#4281EE',
        warning: '#FDC95D'
    },
    coro: {
        primary: '#74E1BF',
        secondary: '#4281EE',
        warning: '#FDC95D'
    },
    censornet: {
        primary: '#0F102C',    // Midnight Wasp primary
        secondary: '#0F102C',  // Midnight Wasp secondary
        warning: '#ffcf00'     // Midnight Wasp tertiary
    }
};


export const getDefaultThemeColors = () => {
    const environment = process.env.REACT_APP_BRAND_TYPE || 'boxphish';
    return themes[environment] || themes.boxphish;
};

export const ThemeProvider = ({ children }) => {
    const [customColors, setCustomColors] = useState(() => getThemeColors() || getDefaultThemeColors());
    const [themeMode, setThemeMode] = useState(() => getThemeMode() || 'light');

    const updateThemeColors = async (newColors) => {
        await saveThemeColors(newColors);
        setCustomColors(newColors);
    };

    const updateThemeMode = async (newMode) => {
        await saveThemeMode(newMode);
        setThemeMode(newMode);
    };

    useEffect(() => {
        const loadedColors = getThemeColors();
        if (loadedColors) {
            setCustomColors(loadedColors);
        }
        const mode = getThemeMode();
        if (mode) {
            setThemeMode(mode);
        }
    }, []);

    return (
        <ThemeContext.Provider value={{ customColors, themeMode, updateThemeColors, updateThemeMode }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useThemeContext = () => useContext(ThemeContext);
